var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000001487(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E8F7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6879 20.9691L20.8662 20.963L20.8662 24.7908L19.128 24.7847L19.128 20.9691L15.3123 20.9691L15.3123 19.0309L19.128 19.0309L19.134 15.2092L20.8662 15.2092L20.8662 19.037L24.6879 19.0309L24.6879 20.9691Z",
    fill: "#4FAF5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000001487);
export default __webpack_public_path__ + "static/media/Group 1000001487.44fdd0b6e8a4c49f327bb5666a4dc0db.svg";
export { ForwardRef as ReactComponent };